import {
  IconBroadcast,
  IconCashBanknote,
  IconCreditCard,
  IconDeviceTv,
  IconHelp,
  IconPaywall,
  IconSitemap,
  IconUsers,
  IconUserUp,
} from "@tabler/icons-react";
import { NavbarRoute } from "../../Lib/Types";

export const routes: NavbarRoute[] = [
  { link: "plans", label: "Plans", icon: IconDeviceTv },
  { link: "subscriptions", label: "Subscriptions", icon: IconBroadcast },
  { link: "transactions", label: "Transactions", icon: IconCreditCard },
  { link: "temps", label: "Pending", icon: IconPaywall },
  { link: "team", label: "Team", icon: IconSitemap },
  { link: "users", label: "Users", icon: IconUsers },
  { link: "promoters", label: "Promoters", icon: IconUserUp },
  { link: "support", label: "Tickets", icon: IconHelp },
  {
    link: "offline-payments",
    label: "Offline",
    icon: IconCashBanknote,
  },
];
